import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import { Tab } from '@material-ui/core/';
const styles = (theme) => createStyles({
    tab: {
        minWidth: 50,
        color: theme.color.font.dark,
        fontWeight: theme.font.weight.bold,
    },
    tabSelected: {
        backgroundColor: theme.color.background.light,
    },
});
const TabButton = (props) => {
    const { classes, text, selected, fullWidth, onChange, textColor, value, onClick, testId = 'TabButton' } = props;
    return (React.createElement(Tab, { classes: { root: classes.tab, selected: classes.tabSelected }, label: text, selected: selected, fullWidth: fullWidth, onChange: onChange, onClick: onClick, textColor: textColor, value: value, "data-testid": `${testId}` }));
};
const ComposedTabButton = compose(withStyles(styles, { withTheme: true }), pure)(TabButton);
ComposedTabButton.displayName = 'TabButton';
export default ComposedTabButton;
//# sourceMappingURL=TabButton.js.map